import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  city: 'Ciudad de México, México'
}, {
  name: 'Carolina S.',
  city: 'Bogotá, Colombia'
}, {
  name: 'Valentina R.',
  city: 'Santiago, Chile'
}, {
  name: 'Luciana M.',
  city: 'Lima, Perú'
}, {
  name: 'Florencia G.',
  city: 'Quito, Ecuador'
}, {
  name: 'Romina P.',
  city: 'Montevideo, Uruguay'
}, {
  name: 'Agustina D.',
  city: 'Guadalajara, México'
}, {
  name: 'Camila T.',
  city: 'Medellín, Colombia'
}, {
  name: 'Daniela F.',
  city: 'San José, Costa Rica'
}, {
  name: 'Sofía B.',
  city: 'Asunción, Paraguay'
}, {
  name: 'Antonella V.',
  city: 'Caracas, Venezuela'
}, {
  name: 'Belén O.',
  city: 'La Paz, Bolivia'
}, {
  name: 'Julieta C.',
  city: 'Guatemala, Guatemala'
}, {
  name: 'Micaela H.',
  city: 'Panamá, Panamá'
}, {
  name: 'Paula E.',
  city: 'Santo Domingo, R. Dominicana'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 2;
}
function getRandomIndex(exclude: number) {
  let next = Math.floor(Math.random() * PURCHASES.length);
  while (next === exclude && PURCHASES.length > 1) {
    next = Math.floor(Math.random() * PURCHASES.length);
  }
  return next;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(() => Math.floor(Math.random() * PURCHASES.length));
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    // First popup appears after 4s
    const initial = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(initial);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Show for 4s
    const hide = setTimeout(() => {
      setVisible(false);
      // Show next after 3s gap → total cycle ~ 7s
      const showNext = setTimeout(() => {
        setCurrentIndex(prev => getRandomIndex(prev));
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, 3000);
      return () => clearTimeout(showNext);
    }, 4000);
    return () => clearTimeout(hide);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-[60] max-w-[240px] transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-280">
      <div className="bg-[#ffffff] border border-[#2E4F48]/15 rounded-lg p-2.5 shadow-lg" data-id="element-281">
        <div className="flex items-start gap-2.5" data-id="element-282">
          <div className="w-7 h-7 rounded-full bg-[#C2683D]/15 border border-[#C2683D]/30 flex items-center justify-center flex-shrink-0" data-id="element-283">
            <span className="text-xs" data-id="element-284">✨</span>
          </div>
          <div className="min-w-0" data-id="element-285">
            <p className="text-[#1C3B36] text-xs font-semibold leading-tight" data-id="element-286">
              {purchase.name}
              <span className="text-[#44574F] font-normal" data-id="element-287"> de </span>
              <span className="text-[#C2683D]" data-id="element-288">{purchase.city}</span>
            </p>
            <p className="text-[#44574F] text-[11px] mt-0.5 leading-snug" data-id="element-289">
              adquirió la{' '}
              <span className="text-[#1C3B36] font-semibold" data-id="element-290">
                Formación en Biodescodificación
              </span>
            </p>
            <p className="text-[#44574F] text-[9px] mt-0.5" data-id="element-291">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}